// extracted by mini-css-extract-plugin
export var chatHtmlText = "_s1-2";
export var chatLink = "_s1-0";
export var chatText = "_s1-1";